import { IMenuItem } from '@models/Header/IMenuItemModel';
import { Grid } from '@ui-kit/Grid';
import { MyLink } from '@ui-kit/Link';
import { LinkAction } from '@sharedComponents/LinkAction';

import styles from './WrapperColumn.module.scss';

export const WrapperColumn = ({ title, url, items }: IMenuItem): JSX.Element => {
  return (
    <Grid column gap={'18px'}>
      {url ? (
        <MyLink className={styles.Title} href={url || ''} data-testid={`footer-${url || ''}`}>
          {title}
        </MyLink>
      ) : (
        <div className={styles.Title}>{title}</div>
      )}
      <Grid className={styles.Links} column>
        {items
          ?.filter(x => x?.title !== 'Честный ЗНАК')
          ?.map(link =>
            link?.title === 'Акции' ? (
              <LinkAction key={link?.title} color="orange" data-testid="footer-btn-actions" />
            ) : (
              <MyLink key={link?.title} className={styles.Item} href={link?.url} data-testid={`footer-${link?.url || ''}`}>
                {link?.title}
              </MyLink>
            ),
          )}
      </Grid>
    </Grid>
  );
};
